import React, { Component } from "react";
import { FormattedMessage, defineMessages } from "react-intl";
import isEmpty from "assets/scripts/utils/isEmpty";
import getPasswordError from "assets/scripts/utils/getPasswordError";
import mapBackendErrors from "assets/scripts/utils/mapBackendErrors";
import TextFormGroup from "assets/scripts/components/common/form/TextFormGroup/TextFormGroup";
import { REQUIRED } from "assets/scripts/constants/FormMessages";
import CaptchaForm from "assets/scripts/components/common/form/CaptchaForm/CaptchaForm";
const messages = defineMessages({
    submit: {
        id: "forms.passwordForgot.submit",
        defaultMessage: "Save Password"
    },
    passwordLabel: {
        id: "forms.passwordForgot.password.label",
        defaultMessage: "New password"
    },
    passwordConfirmLabel: {
        id: "forms.passwordForgot.passwordConfirm.label",
        defaultMessage: "Confirm your password"
    },
    passwordConfirmHelp: {
        id: "forms.passwordForgot.passwordConfirm.help",
        defaultMessage: "Must match the new password field"
    },
});
function getErrors(value) {
    const passwordValid = value.password.length > 0;
    const passwordConfirmValid = value.passwordConfirm.length > 0;
    const passwordsMatch = value.password === value.passwordConfirm;
    return {
        securityAnswer: isEmpty(value.securityAnswer) ? REQUIRED : null,
        password: getPasswordError(passwordValid, passwordConfirmValid, passwordsMatch),
        passwordConfirm: getPasswordError(passwordConfirmValid, passwordValid, passwordsMatch)
    };
}
export default class PasswordForgotForm extends Component {
    constructor(props, context) {
        super(props, context);
        this._handleSecurityAnswerChange = (securityAnswer) => this.setState({ securityAnswer });
        this._handlePasswordChange = (password) => this.setState({ password });
        this._handlePasswordConfirmChange = (passwordConfirm) => this.setState({ passwordConfirm });
        this.state = {
            securityAnswer: "",
            password: "",
            passwordConfirm: ""
        };
        this._handleSubmit = this._handleSubmit.bind(this);
    }
    render() {
        const { props, state: value } = this;
        const errors = getErrors(value);
        const isValid = Object.values(errors).every(it => it == null);
        const { globalError, backendErrors } = mapBackendErrors(props.fieldErrors);
        const { securityQuestion } = props;
        return (<CaptchaForm isBusy={props.isLoading} isValid={isValid} onSubmit={this._handleSubmit} submitLabel={messages.submit} error={globalError}>
				{captcha => (<fieldset className="fieldset">
						<legend>
							<span className="u-isVisuallyHidden">
								<FormattedMessage id="forms.passwordForgot.legend" defaultMessage="Security Information"/>
							</span>
						</legend>

						<TextFormGroup name="securityAnswer" label={props.locale === "es" ? securityQuestion.questionES : securityQuestion.question} value={value.securityAnswer} onChange={this._handleSecurityAnswerChange} error={errors.securityAnswer} backendError={backendErrors.securityAnswer} inputProps={{ autoComplete: "security-answer" }} required/>

						<TextFormGroup type="password" name="password" label={messages.passwordLabel} value={value.password} onChange={this._handlePasswordChange} error={errors.password} backendError={backendErrors.password} inputProps={{ autoComplete: "new-password" }} required/>

						<TextFormGroup type="password" name="passwordConfirm" label={messages.passwordConfirmLabel} help={messages.passwordConfirmHelp} value={value.passwordConfirm} onChange={this._handlePasswordConfirmChange} error={errors.passwordConfirm} inputProps={{ autoComplete: "new-password" }} required/>

						{captcha}

						{process.env.CLIENT !== "CapOne" && (<div className="text">
							<FormattedMessage id="passwordChange.consent" defaultMessage="By clicking Save Password, you consent to receive a one-time password reset email." tagName="p"/>
						</div>)}
					</fieldset>)}
			</CaptchaForm>);
    }
    _handleSubmit(captcha) {
        this.props.resetPassword(this.state, this.props.userId, this.props.token, captcha || undefined);
    }
}



// WEBPACK FOOTER //
// ./src/assets/scripts/components/forms/public/PasswordForgotForm.tsx